import React from "react";
import ShirongGe from './../assets/avatars/ShirongGe.jpg'
import QingxueHuang from './../assets/avatars/QingxueHuang.jpg'

const AdvisoryTeamChair = () => {

  const advisoryTeamChairs = [
    {
      pic: QingxueHuang,
      name: "Qingxue Huang (Co-chair)",
      position: "Academician",
      affiliation: "Taiyuan University of Technology",
      url: "https://en.wikipedia.org/wiki/Huang_Qingxue/"
    },
    {
      pic: ShirongGe,
      name: "Shirong Ge (Co-chair)",
      position: "Academician", 
      affiliation: "Jiangxi University of Science and Technology",
      url: "https://www.researchgate.net/profile/Shirong-Ge"
    }
  ]

  return (
      <div className="flex flex-row flex-wrap content-start items-center justify-around">
        {[...advisoryTeamChairs].map((chair, index) => {
          return (
            chair.url ? 
            <a href={chair.url} key={`advisoryTeamChairs-${index}`} className="hover:opacity-80" target="_blank" rel="noreferrer">
            <div className="md:w-48 w-36 m-4 md:m-8">
              <img className="w-full" src={chair.pic} alt={`avatar-${chair.name}-${index}`} 
               style={{ height: '200px', objectFit: 'cover', borderRadius: '50%' }} />
              <div style={{ fontWeight: 'bold' }}>{chair.name}</div>
              <div>{chair.position}</div>
              <div style={{ fontWeight: 'bold' }}>{chair.affiliation}</div>
            </div>
            </a>
            :
            <span key={`advisoryTeamChairs-${index}`}>
            <div className="md:w-48 w-36 m-4 md:m-8">
              <img className="w-full" src={chair.pic} alt={`avatar-${chair.name}-${index}`} 
               style={{ height: '200px', objectFit: 'cover', borderRadius: '50%' }} />
              <div style={{ fontWeight: 'bold' }}>{chair.name}</div>
              <div>{chair.position}</div>
              <div style={{ fontWeight: 'bold' }}>{chair.affiliation}</div>
            </div>
            </span>
          )
        })}
      </div>
  );
}

export default AdvisoryTeamChair;
